import { cx } from '@emotion/css';
import { FC, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  className?: string;
  boxShadowColor?: string;
};

export const Card: FC<Props> = ({
  children,
  className,
  boxShadowColor = 'rgba(145, 158, 171, 0.12)',
}) => (
  <div
    className={cx(
      'rounded-2xl px-6 py-4 w-full h-full relative overflow-hidden',
      className ? className : ''
    )}
    style={{
      boxShadow: `${boxShadowColor} 0px 0px 2px 0px, ${boxShadowColor} 0px 12px 24px -4px`,
      minHeight: '100px',
    }}
  >
    {children}
  </div>
);
